import {
    ComponentDefinition,
    ValueComponent,
    ValueComponentDefinition,
} from "components/components/Component";
import { ValueBaseComponent } from "components/components/ValueBaseComponent";
import { Renderer } from "components/Renderer";
import { InlineMessage, InlineMessageValue } from "./inlineMessage";
import "./inlineMessage.scss";

export class InlineMessages extends ValueBaseComponent<InlineMessagesComponentDefinition> implements ValueComponent {
    public id: string;
    public componentType: "inlineMessages";

    constructor(definition: InlineMessagesComponentDefinition) {
        super(definition);
        if (definition.width == null) {
            definition.width = 16;
        }
    }
    public render(): Element {
        let d = document.createElement("div");
        this.view = d as HTMLElement;
        return this.view;
    }

    public getValue() {
        return null;
    }

    public value(data: InlineMessagesValue): void {
        this.view.innerHTML = "";
        let i = 0;
        for (const messageValue of data.messages) {
            let message = Renderer.instance().build({
                property: "prop-" + i++,
                id: "id-" + i,
                componentType: "inlineMessage",
            } as ComponentDefinition) as InlineMessage;
            Renderer.instance().render(message);
            message.value(messageValue);
            this.view.appendChild(message.view);
        }
    }
}

export interface InlineMessagesComponentDefinition extends ValueComponentDefinition {
}

export interface InlineMessagesValue extends ValueComponentDefinition {
    messages: InlineMessageValue[];
}
